import React, { useState, useEffect } from 'react';
import WebApp from '@twa-dev/sdk';
import { TonConnectButton } from '@tonconnect/ui-react';
import './HomeScreen.css';

const HomeScreen = ({ onWalletConnect }) => {
  const [gameStats, setGameStats] = useState({
    playerCount: 0,
    prizePool: 0,
    entryFee: 1, // Initial entry fee in TON
  });

  useEffect(() => {
    // Initialize the app
    WebApp.ready();
    WebApp.expand();
    
    // TODO: Fetch game stats from smart contract
    // This is a placeholder for now
    setGameStats({
      playerCount: 42,
      prizePool: 42,
      entryFee: 1,
    });
  }, []);

  return (
    <div className="home-screen">
      <div className="game-header">
        <h1 className="game-title">Last Alive</h1>
        <div className="game-stats">
          <div className="stat-item">
            <span className="stat-label">Players</span>
            <span className="stat-value">{gameStats.playerCount}</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Prize Pool</span>
            <span className="stat-value">{gameStats.prizePool} TON</span>
          </div>
          <div className="stat-item">
            <span className="stat-label">Entry Fee</span>
            <span className="stat-value">{gameStats.entryFee} TON</span>
          </div>
        </div>
      </div>

      <div className="connect-section">
        <TonConnectButton />
        <p className="connect-hint">
          Connect your TON wallet to join the game
        </p>
      </div>

      <div className="game-info">
        <h2>How to Play</h2>
        <ul>
          <li>Connect your TON wallet</li>
          <li>Pay the entry fee to join</li>
          <li>Check in every 24 hours</li>
          <li>Be the last one standing to win!</li>
        </ul>
      </div>
    </div>
  );
};

export default HomeScreen; 